/**
 * APP 推荐位Key值枚举
 */
export enum CROSS_SELL_APP_KEY {
  PARCEL_PANEL = "5crtj8wVLilMPO2W4m25bq13EeoSlL6g",
  PARCEL_PANEL_INSURANCE = "cnyFNFdhcwMncm35A88NoOJAR7tjVoVB",
  RETURN = "HILSZlKlWgM4zhk1GYjawvijNn0Eab9z",
}

/**
 * 推荐位枚举
 */
// lib/cross-sell-tracking/cross-sell-point.ts
export enum CROSS_SELL_POINT_ENUM {
  /**
   * Return to PP
   */
  integration = "494fd99d-c315-4766-acf0-27270ab6e00b",
  managementListFilter = "b8603edb-d010-4070-b325-1b0180730683",
  settingsRule = "975a561f-a95b-4fb9-a89e-71c25394a22f",
  managementUninstallBanner = "f4b2fc8b-b2cd-4627-afd8-32ea4acff50c",

  /**
   * Contact Cross Sell 推荐位
   */
  BannerContact = "57b01a2f-4a1a-4a1a-bf95-d466158806b8",
  HelpCenterContact = "0d5d2612-fbd3-477b-9710-a7cd6f2c1bd6",
}
